import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IFooterConfig } from '@nibtravel/shared/ui/components/footer';
import { ILogoConfig } from '@nibtravel/shared/ui/components/logo';

/**
 * The base layout component with the minimum setup.
 * We still need to add ways to receive navigation content and footer content.
 *
 * This is part of two separate tickets and should be done
 * when we have more clarity on how would that work with CMS
 */
@Component({
  selector: 'nibtravel-base-layout',
  templateUrl: 'base-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseLayoutComponent {
  @Input() logoConfig!: ILogoConfig;
  @Input() footerConfig!: IFooterConfig;
}
